import { AbstractControl, ValidationErrors } from "@angular/forms";

export const MINIMUM_PAYMENT_REAIS = 1;
export const MINIMUM_PAYMENT_MESSAGE =
  "Cada cobrança de Pix ou cartão deve ser de pelo menos R$ 1,00.";

export function validPaymentAmount(reais: number): boolean {
  return Number.isFinite(reais) && reais >= MINIMUM_PAYMENT_REAIS;
}

export function validTicketPrice(reais: number): boolean {
  return reais === 0 || validPaymentAmount(reais);
}

export function minimumTicketPrice(control: AbstractControl): ValidationErrors | null {
  if (control.value === null || control.value === "") return null;
  return validTicketPrice(Number(control.value)) ? null : { minimumTicketPrice: true };
}
